import security from '@/services/security'
export default [
    {
        path: '/',
        name: 'home',
        component: () => import('@/views/dashboard'),
        beforeEnter: async (to, from, next) => {
            if(!await security.authGuard(['ROLE_USER', 'ROLE_ADMIN'])) next('/security/login');
            else next()
        }
    },
    {
        path: '/account',
        name: 'account',
        component: () => import('@/views/user/account'),
        beforeEnter: async (to, from, next) => {
            if(!await security.authGuard(['ROLE_USER', 'ROLE_ADMIN'])) next('/security/login');
            else next()
        }
    },
    {
        path: '/site/create',
        name: 'site.create',
        component: () => import('@/views/site/form'),
        beforeEnter: async (to, from, next) => {
            if(!await security.authGuard(['ROLE_USER', 'ROLE_ADMIN'])) next('/security/login');
            else next()
        }
    },
    {
        path: '/site/:site',
        name: 'site.detail',
        component: () => import('@/views/site/detail'),
        beforeEnter: async (to, from, next) => {
            if(!await security.authGuard(['ROLE_USER', 'ROLE_ADMIN'])) next('/security/login');
            else next()
        }
    },
    {
        path: '/service/:service',
        name: 'service.detail',
        component: () => import('@/views/service/detail'),
        beforeEnter: async (to, from, next) => {
            if(!await security.authGuard(['ROLE_USER', 'ROLE_ADMIN'])) next('/security/login');
            else next()
        }
    },
    {
        path: '/security',
        name: 'security',
        component: () => import('@/views/security/index'),
        children: [
            {
                path: 'login',
                name: 'security.login',
                component: () => import('@/views/security/login')
            },
            {
                path: 'signup',
                name: 'security.signup',
                component: () => import('@/views/security/signup')
            },
            {
                path: 'forgot-password',
                name: 'security.forgot-password',
                component: () => import('@/views/security/forgot-password')
            },
            {
                path: 'reset-password/:token',
                name: 'security.reset-password',
                component: () => import('@/views/security/reset-password')
            },
            {
                path: 'active-account/:token',
                name: 'security.active-account',
                component: () => import('@/views/security/active-account')
            }
        ]
    },
    {
        path: '*',
        redirect: '/'
    }
];
